import React from 'react'
import { Subscribe } from 'unstated'
import CourseStore from '../../../Store/CourseStore'

const Banner = () => (
  <Subscribe to={[CourseStore]}>
    {({ state }) => (
      <div className='banner'>
        <div className='stat'>
          <div className='icon classes' />
          <p className='name'>{state.noOfClasses} Live Video Class</p>
        </div>
        <div className='stat'>
          <div className='icon studyMaterial' />
          <p className='name'>Study material</p>
        </div>
        <div className='stat'>
          <div className='icon weekly' />
          <p className='name'>Weekly Classes</p>
        </div>
      </div>
    )}
  </Subscribe>
)

export default Banner
